const ROOT = process.env.REACT_APP_PORTFOLIO_API_URL;

export const MONITOR = ROOT + '/monitor';
export const MONITOR_RULES = ROOT + '/monitorRules';
export const PORTFOLIO = ROOT + '/portfoliooverview';
export const PAYMENT_BEHAVIOR = ROOT + '/paymentbehavior';
export const EXCEL_FILTERED = PORTFOLIO + '/excelfiltered';
export const PORTFOLIO_OVERVIEW = PORTFOLIO + '/monitorportfolio';
export const MONITOR_PORTFOLIO_EXCEL_FILTERED = PORTFOLIO + '/monitorportfolioexcelfiltered';

export const MONITOR_LIST = MONITOR + '/listsimple';
export const DD_EVENTS = `${MONITOR}/getddevents`;
export const CIP_EVENTS = `${MONITOR}/getcipevents`;
export const CIP_STRENGTH_EVENTS = `${MONITOR}/getcipstrengthevents`;
export const ADD_TO_MONITOR = `${MONITOR}/addtomonitor`;
export const ADD_FILE_TO_MONITOR = `${MONITOR}/addtomonitorfromfile`;
export const MONITOR_OVERVIEW = `${MONITOR}/overview`;
export const WATCHLIST = MONITOR + '/watchlist';
export const STATISTICS = MONITOR + '/statistics';
export const REMOVE_WATCHLIST = MONITOR + '/removefromwatchlist';

export const IS_SHARING = `${PAYMENT_BEHAVIOR}/issharing`;
export const EXCLUSIONS = `${PAYMENT_BEHAVIOR}/exclusions`;
export const ADD_EXCLUSIONS = `${PAYMENT_BEHAVIOR}/addexclusions`;
export const REMOVE_EXCLUSION = `${PAYMENT_BEHAVIOR}/removeexclusion`;

export const MONITOR_RULES_LIST = MONITOR_RULES + '/rules';
export const MONITOR_RULES_UPDATE = MONITOR_RULES + '/updaterules';
